"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Button_1 = __importStar(require("../../components/Button"));
const table_module_scss_1 = __importDefault(require("./table.module.scss"));
const TableButtons = ({ row, buttons }) => {
    return ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: table_module_scss_1.default.table_buttons }, { children: buttons.map((_a, index) => {
            var _b;
            var { text, isLoading, disabled, href, onClick, as: renderedAs = 'button', size = 'sm', shape = 'outlined', variant = 'light', linkWrapper } = _a, restProps = __rest(_a, ["text", "isLoading", "disabled", "href", "onClick", "as", "size", "shape", "variant", "linkWrapper"]);
            const commonProps = Object.assign({ key: index, isLoading: typeof isLoading === 'function' ? isLoading(row) : isLoading, disabled: typeof disabled === 'function' ? disabled(row) : disabled, size,
                shape,
                variant, onClick: (e) => onClick === null || onClick === void 0 ? void 0 : onClick(row, e) }, restProps);
            const anchorProps = {
                href: (_b = (typeof href === 'function' ? href(row) : href)) !== null && _b !== void 0 ? _b : '',
                linkWrapper
            };
            return renderedAs === 'button' ? ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({}, commonProps, { children: text }), void 0)) : ((0, jsx_runtime_1.jsx)(Button_1.AnchorButton, Object.assign({}, anchorProps, commonProps, { children: text }), void 0));
        }) }), void 0));
};
exports.default = TableButtons;
